define('views/shared/panel/panel',[
    'views/_base/baseview'
], function(BaseView){
    'use strict';

    return BaseView.extend({

        panel_enums: {
            wallet  : 0,
            profile : 1,
            transfer: 2
        },

        show: function(){
            this.open();
            this.cleanup();
            this.addClassNames();
        },

        open: function(panel){
            var panel = panel || this;
            panel.is_open = true;
            $(panel.$el).parent().addClass('open');
        },

        hide: function(panel){
            var panel = panel || this;
            panel.removeClassNames();
            panel.closePanel();
        },

        closePanel: function(panel){
            var panel = panel || this;
            panel.is_open = false;
            $(panel.$el).parent().removeClass('open');
        },

        cleanup: function(){
            if(pf.profile.is_open && pf.transfer.is_open){

                if(this.panel_type == this.panel_enums.profile){
                    this.hide(pf.transfer);
                } else if(this.panel_type == this.panel_enums.transfer){
                    this.hide(pf.profile);
                }

            }
        },

        addClassNames: function(){
            // This functionality is only for the profile and tranfer panels
            if(this.panel_type == this.panel_enums.wallet){
                return false;
            }

            $('#main-container').addClass('panel-present');

            if(this.panel_type == this.panel_enums.profile){
                $('#content-inner-container').addClass('panel').addClass('left-panel');
            } else if(this.panel_type == this.panel_enums.transfer){
                $('#content-inner-container').addClass('panel').addClass('right-panel');
            }
            
        },

        removeClassNames: function(){
            // This functionality is only for the profile and tranfer panels
            if(this.panel_type == this.panel_enums.wallet){
                return false;
            }

            $('#main-container').removeClass('panels-present').removeClass('panel-present');
            $('#content-inner-container').removeClass('panel').removeClass('panels').removeClass('right-panel').removeClass('left-panel');
        },

        showNextStep: function(){
            var position = (this.panel_type == this.panel_enums.profile) ? 'left' : 'right';
            this.$el.find('.panel-primary-container').addClass('position-'+position);
            this.$el.find('.panel-secondary-container').addClass('position-center');
        },

        showPanelHome: function(){
            var position = (this.panel_type == this.panel_enums.profile) ? 'left' : 'right';
            this.$el.find('.panel-primary-container').removeClass('position-'+position);
            this.$el.find('.panel-secondary-container').removeClass('position-center').addClass('position-'+position);
            // pf.navigate('profile');
        },

        destroy: function(){
            if(this.is_open){
                this.hide();
            }
            // Backbone remove function removes the view as well as it's element from the DOM
            this.remove();
        },

        close: function(){}
    });
});

